import {useStaticQuery, graphql} from 'gatsby';

const useDefaultPicture = () => {
  const {defaultPicture} = useStaticQuery(graphql`
    query defaultPictureQuery {
      defaultPicture: file(name: {regex: "/default-picture/"}) {
        id
        name
        relativePath
        publicURL
        childImageSharp {
          fluid(maxWidth: 450, maxHeight: 300) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `);
  return defaultPicture;
};

export default useDefaultPicture;
